import { useFormikContext } from 'formik'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { OnboardingStepsFormType } from '../../utils/types/auth'
import { IFormikContextType } from '../../utils/types/common'

export const useSignupNavigate = () => {
    const navigate = useNavigate()
    const { values } =
        useFormikContext() as IFormikContextType<OnboardingStepsFormType>

    useEffect(() => {
        if (!values.firstName || !values.lastName) {
            navigate('/signup/')
        }
    }, [])

    return {}
}
